import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'quick-panel',
    templateUrl: './quick-panel.component.html',
    styleUrls: ['./quick-panel.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class QuickPanelComponent implements OnInit{
    date: Date;
    events: any[];
    notes: any[];
    settings: any;

    userActive = false;

    constructor(
        
    ) {
        
    }

    ngOnInit(): void {        
         
    }

    
}
